/**
 * Count truthy values across filter objects. Used by admin-campaigns, admin-dashboard, admin-customers
 * for getActiveFilterCount() to avoid duplicated logic.
 */
export function countActiveFilterValues(...objects: (Record<string, any> | undefined | null)[]): number {
  return objects.reduce((sum, obj) => {
    if (!obj || typeof obj !== 'object') return sum;
    return sum + Object.values(obj).filter(Boolean).length;
  }, 0);
}
